const pt_br = {
    values: {
        'must not be empty': 'obrigatório',
        Apply: 'Aplicar',
        Add: 'Adicionar',
        'add line': 'Adicionar Linha',
        copy: 'Copiar',
        optional: 'Opicional',
        Hour: 'Hora',
        Choose: 'Escolher',
        Save: 'Salvar',
        Cancel: 'Cancelar',
        'Not found file type': 'Tipo de arquivo não encontrado',
        'Back to Well': 'Voltar para o Poço',
        Back: 'Voltar',
        'Search...': 'Buscar...',
        'Need to register at least one import instance in configuration':
            'É necessário configurar uma instância para importação',
        'Only local connections are allowed': 'Apenas conexões locais são permitidas',
        'Could not request the configured resource': 'Não foi possível buscar a configuração',
        'There was an error while importing': 'Ocorreu um erro ao tentar importar',
        'Could not found the requested file': 'Não foi possível encontrar o arquivo',
        'Confirm Import': 'Confirmar importação',
        'Search results': 'Resultado da busca',
        'Select at least one option': 'Selecione pelo menos uma opção',
        Overwrite: 'Sobrescrever',
        'CSB schematic': 'Gráfico de esquemático CSB',
        'This instance is not enabled to import files': 'Essa instância não está habilitada para importar arquivos',
        'Well normalized event type': 'Evento normalizado do Poço',
        'Import a CSB chart': 'Importar gráfico CSB',
        'CSB chart': 'Gráfico CSB',
        'Import schematic from CSB': 'Importar esquemático CSB',
        'Chart settings': 'Configuração do Gráfico',
        'Remove the imported schematic before importing a new one.':
            'Remover o esquemático importado antes de importar um novo.',
        'Edit query (for advanced users)': 'Editar query (para usuários avançados)',
        'Edit query': 'Editar query',
        'EXPRESSION (Pipes)': 'EXPRESSÃO (Pipes)',
        'RESTORE DEFAULT QUERY': 'RESTAURAR CONSULTA PADRÃO',
        'You are already using the default query.': 'Você já está usando a consulta padrão.',
        'Editing this query may cause chart malfunction.':
            'Editar essa consulta pode causar mau funcionamento do gráfico.',
        'last hour': 'Última hora',
        'This field is blocked because you are using manual query':
            'Este campo está bloqueado porque a query manual está ativa',
        'Event types or macros from lookup tables. If the field is empty, the default lookup table will be used':
            'Event types ou macros de lookup tables. Se nenhum valor for inserido, será usada a lookup table padrão',
        'Help with language.': 'Ajuda com a linguagem.',
        'No schematic selected': 'Nenhum esquemático selecionado',
        'Import a schematic to display': 'Importar um esquemático para ser exibido',
        Sections: 'Seções',
        "Don't import": 'Não importar',
        'Casing string': 'Coluna de revestimento',
        'Drill string': 'Coluna de perfuração',
        TUBULAR: 'TUBULARES',
        'Select a option': 'ESCOLHA UMA OPÇÃO',
        Phase: 'Fase',
        'Run name': 'Nome da corrida',
        'Sum Air Gap': 'Somar Air Gap'
    }
}

module.exports = pt_br
